import { API, Storage } from 'aws-amplify';

// @ts-ignore
function cleanEmptyValue(obj) {
  Object.keys(obj).forEach((key) => {
    if (obj[key] === '') {
      // eslint-disable-next-line no-param-reassign
      delete obj[key];
    }
  });

  return obj;
}

// @ts-ignore
export const create = async (member) => API.put(
  'ihrespezialistenBackend',
  '/members',
  { body: cleanEmptyValue(member) },
);

export const read = async () => API.get('ihrespezialistenBackend', '/members', {});

// @ts-ignore
export const update = async (member) => API.post('ihrespezialistenBackend', `/members/${member.id}`, {
  body:
    cleanEmptyValue(member),
});

// @ts-ignore
export const del = async (member) => API.del('ihrespezialistenBackend', `/members/${member.id}`, {});

// @ts-ignore
// tslint:disable-next-line:max-line-length
export const uploadMemberImage = async (title, image) => Storage.put(`public/companies/${title}`, image, { contentType: image.type });

// @ts-ignore
export const uploadImage = (name, image) => Storage.put(name, image, { level: 'public', contentType: 'image/png' });

export const sendToAll = async () => API.get('ihrespezialistenBackend', '/members/inviteAll', {});
